import { Button, LoadingIndicator } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import React from 'react';

interface PrimaryButtonProps {
  children?: React.ReactNode;
  props?: any;
  additionalStyles?: string;
  type?: any;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  link?: string;
  spinnerSize?: 'sm' | 'lg';
  disabled?: boolean;
  openInNewTab?: boolean;
  isLoading?: boolean;
}

const buttonStyles =
  'min-w-[104px] h-fit inline-flex w-fit items-center text-center flex justify-center rounded-md border border-transparent bg-commenda-blue px-4 py-2 text-base font-medium text-white hover:bg-blue-800 focus:outline-none focus:ring-0 focus:ring-offset-0 disabled:bg-gray-100 disabled:hover:bg-gray-100  disabled:focus:0 disabled:cursor-not-allowed disabled:text-gray-400';

const PrimaryButton = ({
  children,
  type,
  onClick,
  link,
  openInNewTab,
  additionalStyles,
  spinnerSize,
  disabled,
  isLoading,
  ...props
}: PrimaryButtonProps) => {
  return type === 'link' ? (
    <a
      href={link}
      {...props}
      target={openInNewTab ? '_blank' : ''}
      rel={openInNewTab ? 'noopener noreferrer' : ''}
      className={cn(buttonStyles, additionalStyles)}
    >
      {children}
    </a>
  ) : (
    <Button
      variant="primary"
      size="sm"
      disabled={disabled || false}
      onClick={onClick}
      type={type ? 'button' : 'submit'}
      {...props}
    >
      {isLoading ? <LoadingIndicator size={16} /> : children}
    </Button>
  );
};

PrimaryButton.defaultProps = {
  children: undefined,
  props: undefined,
  type: undefined,
  onClick: undefined,
  link: '',
  additionalStyles: '',
  openInNewTab: false,
};

export default PrimaryButton;
